<template>
    <swiper @swiper="onSwiper" :lazy="swiperSettings.lazy" :spaceBetween="swiperSettings.spaceBetween" :slidesPerView="swiperSettings.slidesPerView" :pagination='swiperSettings.pagination' :navigation="swiperSettings.navigation" :breakpoints="swiperSettings.breakpoints" class="compare-slider compare-slider--head">
        <swiper-slide v-for="slide in currentCategory" :key="slide.id" class="compare-slider__item">
            <div class="compare-card">
                <div class="compare-card__head">
                    <a class="compare-card__img" :href="slide.url">
                        <img class="compare-card__img-img" :src="slide.photo" alt="" loading="lazy">
                    </a>
                    <a class="compare-card__title" :href="slide.url">{{ slide.name }}</a>
                    <div class="compare-card__price">
                        <span class="price">{{slide.price || '0'}}&nbsp;<i class="rub">₽</i></span></div>
                    <div class="compare-card__info">{{ slide.article }}</div>
                </div>
            </div>
        </swiper-slide>
        <template v-slot:container-end>
            <div class="swiper-controls">
                <div class="swiper-button swiper-button-prev"> </div>
                <div class="swiper-pagination"></div>
                <div class="swiper-button swiper-button-next"></div>
            </div>
        </template>
    </swiper>
</template>

<script>
import {Swiper, SwiperSlide} from "swiper/vue/swiper-vue";
import SwiperCore, {Pagination, Navigation, Controller} from 'swiper';
import {mapState} from "vuex";
SwiperCore.use([Pagination, Navigation, Controller]);

export default {
    name: "HeadSlider",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        categoryId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            headSlider: null,
            swiperSettings: {
                slidesPerView: 1,
                spaceBetween: 0,
                lazy: {
                    loadPrevNext: true,
                },
                pagination: {
                    el: '.compare-slider--head .swiper-pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.compare-slider--head .swiper-button-next',
                    prevEl: '.compare-slider--head .swiper-button-prev',
                },
                breakpoints: {
                    1000: {
                        slidesPerView: 4,
                    },
                    720: {
                        slidesPerView: 3,
                    },
                    520: {
                        slidesPerView: 2,
                    },
                    420: {
                        slidesPerView: 1,
                    }
                },
            }
        }
    },
    computed:{
        currentCategory: {
            get() {
                return this.categories.find(i => i.ID === this.categoryId).items
            }
        },
        ...mapState({
            categories: state => state.categories
        })
    },
    methods: {
        onSwiper(swiper) {
            this.headSlider = swiper
        }
    }
}
</script>

<style scoped>

</style>